import moment from 'moment';
import 'moment/locale/pt-br';
moment.locale('pt-br');

const abbreviatedRelativeTime = {
  s: "%ds",
  ss: "%ds",
  m: "1min",
  mm: "%dmin",
  h: "1h",
  hh: "%dh",
  d: "1d",
  dd: "%dd",
  M: "1m",
  MM: "%dm",
  y: "1a",
  yy: "%da"
};

const date = {
  getDate: (d) => moment(d),

  format: (d, separator = '/') => moment(d).format(`DD${separator}MM${separator}YYYY`),

  unformat: (d, separator = '-') => moment(d).format(`YYYY${separator}MM${separator}DD`),

  addTime: (d, value, type) => moment(d).add(value, type),

  getDay: (d) => moment(d).format('DD'),

  getMonth: (d) => moment(d).format('MM'),

  getAbbreviatedMonth: (d) => moment(d).format('MMM'),

  getCompleteMonth: (d) => moment(d).format('MMMM'),

  getMonthAndYear: (d) => moment(d).format('MM/YYYY'),

  getAbbreviatedDayAndMonth: (d) => moment(d).format('DD/MMM'),

  getPeriod: (d, separator = '/') => moment(d).format(`MMMM${separator}YYYY`),

  getYear: (d) => moment(d).format('YYYY'),

  getHours: (d) => moment(d).format('HH'),

  getMinutes: (d) => moment(d).format('mm'),

  getSeconds: (d) => moment(d).format('ss'),

  getTime: (d) => moment(d).format('HH:mm:ss'),

  getISO: (d) => moment(d).format('YYYY-MM-DDTHH:mm:ss[Z]'),

  getCurrentDate: () => moment(),

  getDaysInMonth: (d) => moment(d).daysInMonth(),

  getDateRange: (startDate, endDate) => dateRange(startDate, endDate),

  getRelativeTime: (d) => moment(d).fromNow(),

  getAbbreviatedRelativeTime: (d) => {
    moment.updateLocale('pt-br-abbr', { relativeTime: abbreviatedRelativeTime });

    const result = moment(d).locale('pt-br-abbr').fromNow(true);

    moment.locale('pt-br');

    return result;
  },

  getUnixTimeStamp: (d) => moment(d).unix(),

  isDateAfter: (d) => moment().isAfter(moment(d)),

  isDateBefore: (d) => moment().isBefore(moment(d)),

  getUTCFilterDate: (d, isEndDate = false) => moment(d)[isEndDate ? 'endOf' : 'startOf']('day')
    .utc()
    .format(),

  getLocalDate: (d) => moment.utc(d).local().format(),

  getFormatedDateAndHour: (d) => {
    const completeDate = date.getLocalDate(d);

    return `${date.format(completeDate)} ${date.getTime(completeDate)}`
  },

  getFormatedDate: (d) => {
    const completeDate = date.getLocalDate(d);

    return date.format(completeDate);
  },

  /**
   * Returns the date and time in the
   * following format dd/mm/yyyy às XXh XXm or - if the param is empty
   * @param {string} - a timestamp
   * @returns {string}
   */
  formatDateAndTime(value) {
    if (!value) return "-";

    return `${date.format(value)} às ${date.getHours(value)}h ${date.getMinutes(value)}m` ;
  }
};

export default date;
